import { Mapper } from '@data/base/mapper';
import { ClienteEntity } from '@domain/dto/cliente/cliente-get.dto';

export class PersonMapper extends Mapper<ClienteEntity> {
  fromJson(param: any): ClienteEntity {
    return param;
  }
}
